const isPositiveInfinity = (x) => x === Number.POSITIVE_INFINITY;
export default isPositiveInfinity;
